import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQAccordion = () => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    
    // We get the FAQ items from translations. If not loaded, fallback to an empty array.
    const faqItems = t('faq.items', { returnObjects: true }) || [];
    const faqData = Array.isArray(faqItems) ? faqItems : [];

    return (
        <section id="faq" className="py-24 relative overflow-hidden">
            <div className="container relative z-10">
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="text-4xl md:text-5xl font-black mb-4">{t('faq.title')}</h2>
                    <p className="text-text-muted">{t('faq.subtitle')}</p>
                </div>

                <div className="max-w-3xl mx-auto space-y-4">
                    {faqData.map((item, index) => (
                        <div key={index} className="glass overflow-hidden transition-all duration-300 border-white/10 active:border-primary/30" data-aos="fade-up" data-aos-delay={index * 100}>
                            <button 
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-6 text-left flex justify-between items-center bg-transparent hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                            >
                                <span className={`font-bold transition-all ${activeIndex === index ? 'text-primary' : 'text-text-main'}`}>
                                    {item.question}
                                </span>
                                <span className={`text-xl transition-transform duration-300 ${activeIndex === index ? 'rotate-45 text-primary' : 'text-text-muted'}`}>
                                    +
                                </span>
                            </button>
                            <div className={`transition-all duration-500 ease-in-out ${activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                                <div className="p-6 pt-0 text-white/70 leading-relaxed border-t border-white/10 bg-white/2">
                                    {item.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            
            {/* Background vector */}
            <div className="absolute top-1/2 left-0 w-64 h-64 bg-secondary/10 blur-[100px] -z-10 rounded-full"></div>
        </section>
    );
};

export default FAQAccordion;
